//import React, { Component } from 'react';
//import { Route, Routes } from 'react-router-dom';
//import AppRoutes from './AppRoutes';
//import { Layout } from './components/Layout';
//import './custom.css';

//export default class App extends Component {
//  static displayName = App.name;

//  render() {
//    return (
//      <Layout>
//        <Routes>
//          {AppRoutes.map((route, index) => {
//            const { element, ...rest } = route;
//            return <Route key={index} {...rest} element={element} />;
//          })}
//        </Routes>
//      </Layout>
//    );
//  }
//}

import { useState, useEffect } from 'react';
import React from 'react';
import toast, { Toaster } from 'react-hot-toast';
import { Truck, BarChart3, Globe2, Shield, Box, Users, ArrowRight, Mail, Phone, MapPin, Check, ArrowUp, Asterisk } from 'lucide-react';
import ReCAPTCHA from "react-google-recaptcha";
import videobanner from './assets/Manage Your Fleet with Confidence (1).mp4';
import mobileBanner from './assets/banner 02.png';
import PopupModal from './PopupModal';

function App() {    

    const [isPopupOpen, setPopupOpen] = useState(false);

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        company: '',
        message: '',
        captchaToken: ''
    });    

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showScrollTop, setShowScrollTop] = useState(false);
    const [captchaToken, setCaptchaToken] = useState(null);

    const loginUrl = process.env.REACT_APP_LOGIN_URL || '/login';

    const [popupFormData, setpopupFormData] = useState({ name: '', mobile: null, company: '', numberoflr: null, numberofbranch: null, message: '', captchaToken });

    useEffect(() => {
        const handleScroll = () => {
            setShowScrollTop(window.scrollY > 400);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const handleCaptcha = (token) => {
        setCaptchaToken(token);
        formData.captchaToken = token;
        popupFormData.captchaToken = token;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log('Form submitted:', formData);

        if (!captchaToken) {
            //setResponse("Please complete the CAPTCHA");
            toast.error('Please complete the CAPTCHA');
            return;
        }
        setIsSubmitting(true);
        //console.log(process.env.REACT_APP_BACKEND_URL);
        try {
            const response = await fetch(process.env.REACT_APP_BACKEND_URL + "/SendMail/send", {           
                method: 'POST',                
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });          

            const data = await response.json();

            console.log(data);

            if (data.success) {
                toast.success('Message sent successfully!');
                setFormData({ name: '', email: '', company: '', message: '',captchaToken: '' });
            } else {
                //throw new Error(data.error || 'Failed to send message');
            }
        } catch (error) {
            console.error('Error sending email:', error);
            toast.error('Failed to send message. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    const handlePopupSubmit = async (e) => {
        e.preventDefault();
        if (!captchaToken) {
            //setResponse("Please complete the CAPTCHA");
            toast.error('Please complete the CAPTCHA');
            return;
        }        
        setIsSubmitting(true);

        try {
            const response = await fetch(process.env.REACT_APP_BACKEND_URL + "/SendMail/sendquickcontact", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(popupFormData),
            });

            const data = await response.json();

            console.log(data);

            if (data.success) {
                toast.success('Thank you for contacting us! We will get back to you soon.');               
            } else {
                //throw new Error(data.error || 'Failed to send message');
            }
        } catch (error) {
            console.error('Error sending email:', error);
            toast.error('Failed to send message. Please try again.');
        } finally {
            setIsSubmitting(false);
            setPopupOpen(false);
            setpopupFormData({ name: '', mobile: null, company: '', numberoflr: null, numberofbranch: null, message: '' });
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const scrollToSection = (sectionId) => {
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    const pricingPlans = [
        {
            name: 'Lite',
            price: 'Free (up to 400 LR)',
            description: 'Perfect for small businesses just getting started',
            features: [
                'Up to 400 LR per year',
                'Limited support',
                'Advertisements included',
                '5 users & 10 branches',
                'Contact us to extend the limit'
            ],
            highlighted: false,
        },
        {
            name: 'Pay-As-You-Go (On Demand)',
            price: '₹3',
            description: 'Flexible for dynamic and seasonal volume businesses. Bulk discounts and credit carry-forward available.',
            features: [
                'Setup charge ₹3000 (One-time)',
                'Minimum top-up: 1000 LR',
                '1000 LR @ ₹3/LR (valid for 1 year)',
                '5000 LR @ ₹2.5/LR',
                '10,000 LR @ ₹2/LR',
                'Unused LR credit carry-forward',
                //'Party Rate contract',
                'No advertisements',
                'Unlimited branches',
                'Unlimited users',
            ],
            highlighted: false,
        },
        {
            name: 'Plus (Branch-Based)',
            price: 'From ₹5000/Branch',
            description: 'Best for growing businesses. Scaled pricing with more branches and lower rates.',
            features: [
                '1 branch: ₹5000/year',
                '5 branches: ₹3500/year per branch (₹17,500/year)',
                '10 branches: ₹2500/year per branch (₹25,000/year)',
                'Unlimited LR',
                /*'Party Rate contract',*/
                'No advertisements',
                'Unlimited users',
            ],
            highlighted: true,
        },
        {
            name: 'Enterprise',
            price: 'Tailored Pricing',
            description: 'Custom integrations, analytics, and domain options for advanced organizations.',
            features: [
                'All features of Plus',
                'Custom integrations',
                'Advanced analytics & reporting',
                'Custom domain',
                'Custom reporting',
            ],
            highlighted: false,
        },
    ];


    return (
        <div className="min-h-screen bg-white">
            <Toaster position="top-right" reverseOrder={false} />
            {/* Scroll to Top Button */}
            <button
                onClick={scrollToTop}
                className={`fixed bottom-8 right-8 bg-blue-600 text-white p-3 rounded-full shadow-lg transition-all duration-300 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${showScrollTop ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-16 pointer-events-none'
                    }`}
                aria-label="Scroll to top"
            >
                <ArrowUp className="h-6 w-6" />
            </button>

            {/* Hero Section */}
            <header className="relative flex items-center md:min-h-screen">
                {/* Background Image with Overlay */}
                {/*<div*/}
                {/*    className="absolute inset-0 z-0 md:hidden"                    */}
                {/*    style={{*/}
                {/*        backgroundImage: `url(${mobileBanner})`,*/}
                {/*        backgroundSize: 'cover',*/}
                {/*        backgroundPosition: 'center',*/}
                {/*    }}*/}
                {/*>*/}
                                        
                {/*    */}{/*<div className="absolute inset-0 bg-gradient-to-r from-blue-900/50 to-blue-800/50"></div>*/}
                {/*</div>*/}
                <div className="sm:bg-auto" style={{ position: 'relative', width: '100%', overflow: 'hidden', marginTop: '6px' }}> {/*removed height: '100vh', for mobile view*/}
                    <video autoPlay loop muted style={{ width: 'auto', height: 'auto', objectFit: 'fill' }}>
                        <source src={videobanner} type="video/mp4" />
                        Your browser does not support the video tag.
                        </video>
                    {/*<div style={{position: 'absolute',top: 0,left: 0,width: '100%',height: '100%',display: 'flex',flexDirection: 'column',justifyContent: 'center',alignItems: 'center',*/}
                    {/*    backgroundColor: 'rgba(0, 0, 0, 0.5)',*/}
                    {/*}}>*/}
                    {/*    <h1 style={{ color: 'white', fontSize: '3em', marginBottom: '20px' }}>Fleet Management</h1>*/}
                    {/*    <a href="#schedule-demo" style={{ padding: '10px 20px', backgroundColor: '#007BFF', color: 'white', textDecoration: 'none', borderRadius: '5px', }}>*/}
                    {/*        Schedule Demo*/}
                    {/*    </a>*/}
                    {/*    </div>*/}
                </div>


                {/* Navigation */}
                <nav className="fixed left-0 right-0 top-0 z-50 bg-gradient-to-r from-blue-900/95 to-blue-800/95 backdrop-blur-sm">
                    <div className="container mx-auto flex items-center justify-between px-6 py-4">
                        <div className="flex items-center space-x-2">
                            <Truck className="h-8 w-8 text-white" />
                            <span className="text-xl font-bold text-white">The Freight</span>
                        </div>
                        <div className="hidden space-x-8 md:flex">
                            <button onClick={() => scrollToSection('features')} className="text-white hover:text-blue-200 transition-colors">Features</button>
                            <button onClick={() => scrollToSection('solutions')} className="text-white hover:text-blue-200 transition-colors">Solutions</button>
                            <button onClick={() => scrollToSection('pricing')} className="text-white hover:text-blue-200 transition-colors">Pricing</button>
                            <button onClick={() => scrollToSection('contact')} className="text-white hover:text-blue-200 transition-colors">Contact</button>
                            <div class="h-6 w-px bg-white/50"></div>
                            <a target="_blank" href={loginUrl} className="text-white transition-colors hover:text-blue-200">
                                Login
                            </a>
                            
                            <a href="tel:+918128116433" className="text-white transition-colors hover:text-blue-200">
                                <Phone className="mr-2 h-6 w-6" style={{float:"left"}} />
                                +91 8128116433
                            </a>
                        </div>
                        {/*<button className="rounded-lg bg-blue-600 px-6 py-2 font-semibold text-white transition-colors hover:bg-blue-700">*/}
                        {/*    Get Started*/}
                        {/*</button>*/}
                    </div>
                </nav>

                {/* Hero Content */}
              {/*  <div className="container relative z-10 mx-auto mt-16 px-6">*/}
              {/*      <div className="max-w-3xl">*/}
              {/*          <h1 className="mb-6 text-5xl font-bold leading-tight text-white md:text-6xl">*/}
              {/*              Streamline Your Logistic Operations*/}
              {/*          </h1>*/}
              {/*          <p className="mb-8 text-xl text-blue-100">*/}
              {/*              Powerful logistics software that helps you manage inventory, track shipments, and optimize routes.*/}
              {/*          </p>*/}
              {/*          <div className="flex flex-col space-y-4 sm:flex-row sm:space-x-4 sm:space-y-0">*/}
              {/*              <button onClick={() => scrollToSection('contact')} className="bg-blue-600 hover:bg-blue-700 px-8 py-3 rounded-lg font-semibold flex items-center justify-center transition-colors text-white group">*/}
              {/*                  Schedule Demo*/}
              {/*                  <ArrowRight className="ml-2 h-5 w-5 transform transition-transform group-hover:translate-x-1" />*/}
              {/*              </button>*/}
              {/*              */}{/* <button className="rounded-lg bg-white px-8 py-3 font-semibold text-blue-900 transition-colors hover:bg-blue-50">*/}{/*
              */}{/*  Learn More*/}{/*
              */}{/*</button> */}
              {/*          </div>*/}
              {/*      </div>*/}
              {/*  </div>*/}

                {/* Scroll Indicator */}
                {/*<div className="-translate-x-1/2 absolute bottom-8 left-1/2 z-10 transform">*/}
                {/*    <div className="animate-bounce">*/}
                {/*        <div className="relative h-16 w-1 rounded-full bg-white/30">*/}
                {/*            <div className="animate-scroll absolute top-0 h-4 w-1 rounded-full bg-white"></div>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}
            </header>
            {/* Features Section */}
            <section id="features" className="bg-gray-50 py-20">
                <div className="container mx-auto px-6">
                    <h1 className="mb-16 text-center text-3xl font-bold">Powerful Features for Modern Logistics</h1>
                    <div className="grid gap-12 md:grid-cols-3">
                        <FeatureCard
                            icon={<BarChart3 className="h-8 w-8 text-blue-600" />}
                            title="Real-time Analytics"
                            description="Track KPIs and get insights into your operations with advanced analytics and reporting tools."
                        />
                        <FeatureCard
                            icon={<Shield className="h-8 w-8 text-blue-600" />}
                            title="Secure Platform"
                            description="Enterprise-grade security to protect your sensitive logistics and customer data."
                        />
                        <FeatureCard
                            icon={<Globe2 className="h-8 w-8 text-blue-600" />}
                            title="Simple and Easy to use Solution"
                            description="Run from anywhere and anytime with cloud, so no need for on premise setup and save your money."
                        />
                    </div>
                </div>
            </section>

            {/* Solutions Section */}
            <section id="solutions" className="py-20">
                <div className="container mx-auto px-6">
                    <h1 className="mb-16 text-center text-3xl font-bold">Highlight for our Fleet Management System</h1>
                    <div className="grid gap-12 md:grid-cols-2">
                        {/* <SolutionCard
              icon={<Box className="h-8 w-8 text-blue-600" />}
              title="Warehouse Management"
              description="Optimize your warehouse operations with advanced inventory management and picking strategies."
              features={["Inventory Tracking", "Order Management", "Space Optimization"]}
            />
            <SolutionCard
              icon={<Users className="h-8 w-8 text-blue-600" />}
              title="Fleet Management"
              description="Manage your entire fleet with real-time tracking and maintenance scheduling."
              features={["Trip Details", "Maintenance Planning", "Driver Management","Customer Management"]}
            /> */}
                        <SolutionCard
                            icon=""
                            title=""
                            description=""
                            features={["Multiple Branch Creation"
                                , "Branch Level Commission Setting (per KG or % of Freight Amount)"
                                , "Vehicle Management"
                                , "Driver Management"
                                , "Customer Management"
                                , "Branch Commission Calculation"
                                , "Party Ledger"
                                , "Expense Ledger"
                                , "Cash and Bank Book Report"
                            ]}
                        />
                        <SolutionCard
                            icon=""
                            title=""
                            description=""
                            features={["Create LR / Bilty"
                                , "Truck Sheet / Memo"
                                , "Unloading"
                                , "Delivery Note"
                                , "Inventory Tracking"
                                , "Day Book Report"
                                , "Admin Level Statistical Data"
                                , "Branch Level Data Filtering"
                                , "Custom Rate per Party Setting (Party Rate contract)"
                                , 'Ewaybill API (add-on)'
                            ]}
                        />
                    </div>
                </div>
            </section>

            {/* Pricing Section */}
            <section id="pricing" className="bg-gray-50 py-20">
                <div className="container mx-auto px-6">
                    <h2 className="mb-4 text-center text-3xl font-bold">Simple, Transparent Pricing</h2>
                    <p className="mx-auto mb-16 max-w-2xl text-center text-gray-600">
                        Choose the perfect plan for your business. All plans include a 14-day free trial.
                    </p>
                    <div className="grid gap-8 md:grid-cols-3">
                        {pricingPlans.map((plan, index) => (
                            <div
                                key={index}
                                className={`bg-white rounded-2xl shadow-lg overflow-hidden transform transition-transform hover:scale-105 ${plan.highlighted ? 'ring-2 ring-blue-600' : ''
                                    }`}
                            >
                                <div className={`p-8 ${plan.highlighted ? 'bg-blue-600 text-white' : ''}`}>
                                    <h3 className="mb-2 text-2xl font-bold">{plan.name}</h3>
                                    <div className="mb-4">
                                        <span className="text-4xl font-bold">{plan.price}</span>
                                        {plan.name.includes("On Demand") ? <span className="text-gray-500">/LR</span> : 
                                            plan.name === 'Plus' ? <span className={`${plan.highlighted ? 'text-white' : 'text-gray-500'}`}>/year</span> :
                                            plan.price !== 'Custom' && <span className={`${plan.highlighted ? 'text-white' : 'text-gray-500'}`}>/year</span>}
                                    </div>
                                    <p className={`${plan.highlighted ? 'text-blue-100' : 'text-gray-600'}`}>
                                        {plan.description}
                                    </p>
                                </div>
                                <div className="p-8">
                                    <ul className="space-y-4">
                                        {plan.features.map((feature, featureIndex) => (
                                            //|| feature == 'Unlimited users & branches'
                                            <li key={featureIndex} className="flex items-center">
                                                {feature == 'Contact us to extend the limit' 
                                                    ? (<Asterisk className="mr-3 h-3 w-3 text-red-500" />)
                                                    : <Check className="mr-3 h-5 w-5 text-blue-600" />
                                                }
                                                
                                                <span className="text-gray-700">{feature}</span>
                                            </li>
                                        ))}
                                    </ul>
                                    <button onClick={() => setPopupOpen(true)}
                                        className={`w-full mt-8 px-6 py-3 rounded-lg font-semibold transition-colors ${plan.highlighted
                                                ? 'bg-blue-600 text-white hover:bg-blue-700'
                                                : 'bg-gray-100 text-gray-800 hover:bg-gray-200'
                                            }`}
                                    >
                                        {plan.name === 'Enterprise' ? 'Contact Sales' : 'Get Started'}
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="mt-12 text-center">
                        <p className="mb-4 text-gray-600">Need a custom solution?</p>
                        <button onClick={() => scrollToSection('contact')} className="text-blue-600 hover:text-blue-800 font-semibold">
                            Contact us for enterprise pricing →
                        </button>
                    </div>
                </div>
            </section>

            {/* Contact Section */}
            <section id="contact" className="bg-gray-50 py-20">
                <div className="container mx-auto px-6">
                    <h2 className="mb-16 text-center text-3xl font-bold">Get in Touch</h2>
                    <div className="grid gap-12 md:grid-cols-2">
                        {/* Contact Form */}
                        <div className="rounded-xl bg-white p-8 shadow-sm">
                            <h3 className="mb-6 text-2xl font-semibold">Send us a Message</h3>
                            <form onSubmit={handleSubmit} className="space-y-6">
                                <div>
                                    <label htmlFor="name" className="mb-1 block text-sm font-medium text-gray-700">
                                        Name
                                    </label>
                                    <input
                                        type="text"
                                        id="name"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        className="w-full rounded-lg border border-gray-300 px-4 py-2 focus:border-transparent focus:ring-2 focus:ring-blue-600"
                                        required
                                    />
                                </div>
                                <div>
                                    <label htmlFor="email" className="mb-1 block text-sm font-medium text-gray-700">
                                        Email
                                    </label>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        className="w-full rounded-lg border border-gray-300 px-4 py-2 focus:border-transparent focus:ring-2 focus:ring-blue-600"
                                        required
                                    />
                                </div>
                                <div>
                                    <label htmlFor="company" className="mb-1 block text-sm font-medium text-gray-700">
                                        Company
                                    </label>
                                    <input
                                        type="text"
                                        id="company"
                                        name="company"
                                        value={formData.company}
                                        onChange={handleChange}
                                        className="w-full rounded-lg border border-gray-300 px-4 py-2 focus:border-transparent focus:ring-2 focus:ring-blue-600"
                                    />
                                </div>
                                <div>
                                    <label htmlFor="message" className="mb-1 block text-sm font-medium text-gray-700">
                                        Message
                                    </label>
                                    <textarea
                                        id="message"
                                        name="message"
                                        value={formData.message}
                                        onChange={handleChange}
                                        rows="4"
                                        className="w-full rounded-lg border border-gray-300 px-4 py-2 focus:border-transparent focus:ring-2 focus:ring-blue-600"
                                        required
                                    ></textarea>
                                </div>
                                {/* Google reCAPTCHA */}
                                <ReCAPTCHA sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY} onChange={handleCaptcha} />
                                <button
                                    type="submit"
                                    className="w-full rounded-lg bg-blue-600 py-3 font-semibold text-white transition-colors hover:bg-blue-700"
                                >
                                    Send Message
                                </button>
                            </form>
                        </div>

                        {/* Contact Information */}
                        <div className="space-y-8">
                            <div>
                                <h3 className="mb-6 text-2xl font-semibold">Contact Information</h3>
                                <div className="space-y-4">
                                    <div className="flex items-start space-x-4">
                                        <Mail className="mt-1 h-6 w-6 text-blue-600" />
                                        <div>
                                            <p className="font-medium">Email</p>
                                            <a href="mailto:contact@thefreight.in" className="text-blue-600 hover:text-blue-800">
                                                contact@thefreight.in
                                            </a>
                                        </div>
                                    </div>
                                    <div className="flex items-start space-x-4">
                                        <Phone className="mt-1 h-6 w-6 text-blue-600" />
                                        <div>
                                            <p className="font-medium">Phone</p>
                                            <a href="tel:+918128116433" className="text-blue-600 hover:text-blue-800">
                                                +91 8128116433
                                            </a>
                                        </div>
                                    </div>
                                    <div className="flex items-start space-x-4">
                                        <MapPin className="mt-1 h-6 w-6 text-blue-600" />
                                        <div>
                                            <p className="font-medium">Office</p>
                                            <p className="text-gray-600">
                                                403, Ghanshyam Apartments,<br />
                                                Opp. Hare Krishna Flats,<br />
                                                Ahmedabad - 380 007
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <h3 className="mb-6 text-2xl font-semibold">Business Hours</h3>
                                <div className="space-y-2 text-gray-600">
                                    <p>Monday - Friday: 10:00 AM - 7:00 PM IST</p>
                                    {/*<p>Saturday: 10:00 AM - 4:00 PM IST</p>*/}
                                    <p>Saturday - Sunday: Closed</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="bg-blue-900 py-20 text-white">
                <div className="container mx-auto px-6 text-center">
                    <h2 className="mb-6 text-3xl font-bold">Ready to Transform Your Logistics?</h2>
                    <p className="mb-8 text-xl text-blue-100">
                        Join thousands of companies that trust The Freight for their supply chain needs.
                    </p>
                    <button onClick={() => scrollToSection('contact')} className="bg-blue-600 hover:bg-blue-700 px-8 py-3 rounded-lg font-semibold transition-colors">
                        Start Free Trial
                    </button>
                </div>
            </section>

            <PopupModal
                isOpen={isPopupOpen}
                onClose={() => setPopupOpen(false)}
                onPost={handlePopupSubmit}
                isSubmitting={isSubmitting}
                formData={popupFormData}
                setFormData={setpopupFormData}
                handleCaptcha={handleCaptcha}
            />

            {/* Footer */}
            <footer className="bg-gray-900 py-12 text-gray-300">
                <div className="container mx-auto px-6">
                    <div className="grid gap-8 md:grid-cols-4">
                        <div>
                            <div className="mb-6 flex items-center space-x-2">
                                <Truck className="h-6 w-6" />
                                <span className="text-lg font-bold text-white">The Freight</span>
                            </div>
                            <p className="text-sm">
                                Empowering businesses with intelligent logistics solutions since 2024.
                            </p>
                        </div>
                        <div>
                            <h3 className="mb-4 font-semibold text-white">Product</h3>
                            <ul className="space-y-2">
                                <li><button onClick={() => scrollToSection('features')} className="hover:text-white">Features</button></li>
                                <li><button onClick={() => scrollToSection('solutions')} className="hover:text-white">Solutions</button></li>
                                <li><button onClick={() => scrollToSection('pricing')} className="hover:text-white">Pricing</button></li>
                            </ul>
                        </div>
                        {/*<div>*/}
                        {/*    <h3 className="mb-4 font-semibold text-white">Company</h3>*/}
                        {/*    <ul className="space-y-2">*/}
                        {/*        <li><a href="#" className="hover:text-white">About</a></li>*/}
                        {/*        <li><a href="#" className="hover:text-white">Blog</a></li>*/}
                        {/*        <li><a href="#" className="hover:text-white">Careers</a></li>*/}
                        {/*    </ul>*/}
                        {/*</div>*/}
                        <div>
                            <h3 className="mb-4 font-semibold text-white">Support</h3>
                            <ul className="space-y-2">
                                {/*<li><a href="#" className="hover:text-white">Help Center</a></li>*/}
                                {/*<li><a href="#" className="hover:text-white">Documentation</a></li>*/}
                                <li><button onClick={() => scrollToSection('contact')} className="hover:text-white">Contact</button></li>
                            </ul>
                        </div>
                    </div>
                    <div className="mt-12 border-t border-gray-800 pt-8 text-center text-sm">
                        © 2025 The Freight. All rights reserved.
                    </div>
                </div>
            </footer>
        </div>
    );
}

function FeatureCard({ icon, title, description }) {
    return (
        <div className="rounded-xl bg-white p-8 shadow-sm transition-shadow hover:shadow-md">
            <div className="mb-4">{icon}</div>
            <h3 className="mb-3 text-xl font-semibold">{title}</h3>
            <p className="text-gray-600">{description}</p>
        </div>
    );
}

function SolutionCard({ icon, title, description, features }) {
    return (
        <div className="rounded-xl border border-gray-100 bg-white p-8 shadow-sm transition-shadow hover:shadow-md">
            <div className="mb-4">{icon}</div>
            <h3 className="mb-3 text-xl font-semibold">{title}</h3>
            <p className="mb-6 text-gray-600">{description}</p>
            <ul className="space-y-2">
                {features.map((feature, index) => (
                    <li key={index} className="flex items-center text-gray-700">
                        <div className="mr-2 h-1.5 w-1.5 rounded-full bg-blue-600"></div>
                        {feature}
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default App;
